import { render, staticRenderFns } from "./RewardToRedeem.vue?vue&type=template&id=fb154216&scoped=true&lang=pug&"
import script from "./RewardToRedeem.vue?vue&type=script&lang=js&"
export * from "./RewardToRedeem.vue?vue&type=script&lang=js&"
import style0 from "./RewardToRedeem.vue?vue&type=style&index=0&id=fb154216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb154216",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VRadioGroup,VRow,VSkeletonLoader,VTextField})
